<template>
  <q-card
    style="max-width: 800px;width: 50vw;height: 70vh;max-height:600px"
    class="column no-wrap q-pa-xl"
  >
    <header class="row items-center justify-between">
      <div class="row items-center text-bold text-grey-10">
        <q-icon name="fas fa-users" size="2rem" class="q-mr-md" />
        <span style="font-size: 1.5rem">新建小组</span>
      </div>
      <q-icon
        color="grey-5"
        class="cursor-pointer"
        name="fas fa-times-circle"
        size="1.4rem"
        @click="cancelCreate"
      />
    </header>

    <main class="col-grow q-py-md">
      <div class="row items-center full-width">
        <span class="col-2">名称</span>
        <q-input
          v-model="newGroupName"
          class="col-10"
          dense
          outlined
          label="请输入小组名称"
        />
      </div>

      <!-- <div class="row items-center full-width q-mt-md">
        <span class="col-2">关联样本组</span>
        <q-select
          class="col-10"
          dense
          outlined
          label="请选择关联的样本组"
          :value="null"
          dropdown-icon="fas fa-caret-down"
        />
      </div> -->

      <div class="row items-start full-width q-mt-md">
        <span class="col-2">描述</span>
        <q-input
          v-model="newGroupDescription"
          class="col-10"
          label="请输入描述"
          outlined
          type="textarea"
        />
      </div>
    </main>

    <footer class="row items-center justify-center">
      <q-btn outline class="q-px-md q-mr-sm" @click="cancelCreate">
        取消
      </q-btn>
      <q-btn
        flat
        class="text-white bg-primary q-px-md q-ml-sm"
        @click="confirmCreate"
        :disable="notReadyToCreate"
      >
        确认
      </q-btn>
    </footer>
  </q-card>
</template>

<script>
import { createGroup } from "@/api/endpoints/group/createGroup";
export default {
  data() {
    return {
      newGroupName: "",
      newGroupConnectedSampleId: null,
      newGroupDescription: "",
    };
  },

  computed: {
    notReadyToCreate() {
      const { newGroupName, newGroupDescription } = this;
      return !(newGroupName.length > 0 && newGroupDescription.length > 0);
    },
  },

  methods: {
    /**
     * 创建新的小组
     */
    async confirmCreate() {
      const { newGroupName, newGroupDescription } = this;
      try {
        this.$emit("beforeCreate");
        const response = await createGroup({
          name: newGroupName,
          description: newGroupDescription,
        });
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: "创建失败：" + (response.detail || response.message),
          });
        } else {
          this.$q.notify({
            type: "success",
            message: "已创建小组：" + newGroupName,
          });
          this.$emit("created");
          this.cancelCreate();
        }
      } catch (err) {
        console.log(err);
        this.$emit("error", err)
      } finally {
        // await this.fetchUserGroupList();
      }
    },

    cancelCreate() {
      this.newGroupName = "";
      this.newGroupConnectedSampleId = null;
      this.newGroupDescription = "";
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="scss">
i.q-select__dropdown-icon {
  font-size: 1.2rem !important;
}
</style>
